export default {
    firstName: {
        required: true,
        maxlength: 30
    },
    lastName: {
        required: true,
        maxlength: 30
    },
    email: {
        required: true,
        email: true
    },
    policyCheck: {
        required: true,
    },
}